import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './HowDoesItWork2.module.css';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
function HowDoesItWork2(props) {
    const {history}=props;
  return (
    <>
     <div className={css.BusinessWorkWrap}>
      <div className={css.HowDoesItWork2Main}>
        <p className={css.heading}>
          {' '}
          <FormattedMessage id="HowDoesItWork.heading" />
        </p>
        <p className={css.subheading}>
          <FormattedMessage id="HowDoesItWork2.subHeading1" />{' '}
          <span
            className={css.subHeadingSpan}
            onClick={e => {
              e.stopPropagation();
              history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}));
            }}
          >
            <FormattedMessage id="HowDoesItWork2.subSpanHeading" />
          </span>
          <FormattedMessage id="HowDoesItWork2.subHeading2" />
        </p>
        <div className={css.HowDoesItWork2Container1}>
          <div className={css.boxItem}>
            <div className={css.boxItemDescContainer}>
              <h3 className={css.title}>
                <FormattedMessage id="HowDoesItWork2.title1" />
              </h3>
              <p className={css.about}>
                <FormattedMessage id="HowDoesItWork2.about1" />{' '}
              </p>
            </div>
          </div>
          <div className={css.boxItem}>
            <div className={css.boxItemDescContainer}>
              <h3 className={css.title}>
                {' '}
                <FormattedMessage id="HowDoesItWork2.title2" />
              </h3>
              <p className={css.about}>
                <FormattedMessage id="HowDoesItWork2.about2" />{' '}
              </p>
            </div>
          </div>
          <div className={css.boxItem}>
            <div className={css.boxItemDescContainer}>
              <h3 className={css.title}>
                {' '}
                <FormattedMessage id="HowDoesItWork2.title3" />
              </h3>
              <p className={css.about}>
                <FormattedMessage id="HowDoesItWork2.about3" />{' '}
              </p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default compose(withRouter)(HowDoesItWork2)